const CENTRAL_TIME = 'America/Chicago';

const PAYMENT_METHODS = {
  apple: 'Apple',
  stripe: 'Stripe',
  internal: 'None',
};

const OFFER_TYPES = {
  free_trial: 'Free trial',
  pay_as_you_go: 'Intro price, monthly',
  pay_up_front: 'Intro price, paid up front',
};

const OVERCAP_POLICIES = {
  adds_only: 'New adds paused',
  lock_after_window: 'Locks after 30 days',
};

export function formatConversionDay(iso) {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('en-US', {
    timeZone: CENTRAL_TIME,
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  });
}

export function conversionCountdown(daysLeft) {
  if (daysLeft === 0) return 'Today';
  if (daysLeft === 1) return 'Tomorrow';
  return `In ${daysLeft} days`;
}

export function paymentMethodLabel(method) {
  return PAYMENT_METHODS[method] ?? method ?? '—';
}

export function offerLabel(offer) {
  if (offer?.type) return OFFER_TYPES[offer.type] ?? offer.type;
  return offer?.source === 'stripe' ? 'Stripe trial' : '—';
}

export function autoRenewLabel(autoRenew) {
  if (autoRenew === true) return 'Auto-renew on';
  if (autoRenew === false) return 'Auto-renew off';
  return null;
}

export function reminderChoiceLabel(reminder) {
  return reminder?.days ? `${reminder.days} days before` : 'Default';
}

export function reminderStatusLabel(reminder) {
  if (!reminder?.sent) return 'Not sent';
  const sentAt = new Date(reminder.sentAt).toLocaleString('en-US', {
    timeZone: CENTRAL_TIME,
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
  return `Sent ${sentAt} CT`;
}

export function capacity({ count, limit }) {
  if (limit === null || limit === undefined) return { text: `${count}`, detail: 'No limit', over: false };
  return { text: `${count} / ${limit}`, detail: null, over: count > limit };
}

export function overcapLabel(policy) {
  return OVERCAP_POLICIES[policy] ?? '—';
}
